
import TransactionComponent from "../components/TransactionComponent";

import useTransaction from "../hook/useTransaction";

const TransactionPage = ({

}) => {
    const transaction = useTransaction();
    return <TransactionComponent {...transaction} />
}
export default TransactionPage;